<template>
    <div class="NewsPolicies">
        <div class="title-box">
            <span>{{ policiesName.name }}</span>
            <i>{{ policiesName.englishName }}</i>
        </div>
        <ul>
            <RouterLink
                v-for="(item, index) in dataList"
                :key="index"
                :to="{name: 'navPoliciesDetails',query:{xId:item.xId}}"
                tag="li"
            >
                <span>{{ item.xName }}</span>
                <i>></i>
            </RouterLink>
        </ul>
        <ul>
            <RouterLink
                v-for="(item, index) in recommendList"
                :key="index"
                :to="{name: 'navPoliciesDetails',query:{xId:item.xId}}"
                tag="li"
            >
                <span>{{ item.xName }}</span>
                <i>{{ item.showTime | capitalizes }}-{{ item.showTime | capitalize }}</i>
            </RouterLink>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'NewsPolicies',
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[2]
        },
        capitalizes: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[1]
        }
    },
    props: {
        policiesName: {
            type: Object
        },
        dataList: {
            type: Array
        },
        recommendList: {
            type: Array
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.NewsPolicies {
    .title-box {
        display: flex;
        align-content: center;
        span {
            display: block;
            font-size: 25px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            padding: 34px 12px 20px 40px;
            position: relative;
            &::after {
                content: "";
                margin-left: 45px;
                border-left: 4px solid rgba(36, 61, 179, 1);
                height: 26px;
                display: inline-block;
                vertical-align: middle;
                position: absolute;
                top: 39px;
                left: -20px;
            }
        }
        i {
            font-style: normal;
            font-size: 18px;
            font-weight: 300;
            color: #999;
            padding-top: 44px;
        }
    }
    ul {
        margin: 0;
        padding-left: 40px;
        li {
            cursor: pointer;
            font-size: 16px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 24px;
            position: relative;
            list-style: none;
            &::after {
                content: "";
                margin-left: 45px;
                border-left: 4px solid rgba(36, 61, 179, 1);
                height: 4px;
                display: inline-block;
                vertical-align: middle;
                position: absolute;
                top: 16px;
                left: -60px;
            }
            span {
                margin: 0;
                line-height: 38px;
                display: inline-block;
                height: 100%;
                width: 250px;

                /* 设置文本框大小 */
                white-space: nowrap;

                /* 设置内容不换行 */
                text-overflow: ellipsis;

                /* 设置文字超出文本框的内容显示成... */
                overflow: hidden;
            }
            i {
                font-style: normal;
                display: block;
                float: right;
                height: 100%;
                line-height: 38px;
                margin-right: 24px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
            }
        }
    }
}
</style>
